export function LoadingOverlay({ message = "Loading your crossword...", hint }: { message?: string; hint?: string }) {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner" />
      <p>{message}</p>
      {hint && <p className="loading-hint">{hint}</p>}
    </div>
  )
}
